import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { getBongoUrl } from '../../../common/utils/bongo';

export function useZoomInfoIsConnected(tenant: number) {
  return useQuery<boolean>({
    queryKey: ['zoominfo', tenant],
    queryFn: async () => {
      const { data } = await axios.get(
        `${getBongoUrl()}/v1/org/${tenant}/integrations/zoominfo`
      );

      return !!data?._id;
    },
    retry: false,
  });
}
